import { defineStore } from 'pinia'

import type { ProgressReportStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'

export const useProgressReportStore = defineStore('progress-report', {
  state: (): ProgressReportStore => ({
    reportLoading: false,
    reportsLoading: false,
    reportsEla: [],
    reportsMath: [],
    reportEla: null,
    reportMath: null,
    newProgressReportMath: false,
    newProgressReportEla: false,
  }),
  actions,
  getters,
})
